export class GoogleTagManager {

    init() {
        this.addEventListeners();
    }

    /**
     * Event listeners
     */
    addEventListeners() {
        // Add to cart / remove from cart event
        document.addEventListener('GTMAmountChanged', (event) => {
            this.eventListenerAmountChanged(event);
        });

        // View item event
        document.addEventListener('GTMViewItem', (event) => {
            this.viewItemEvent(event);
        });

        // View item list event
        document.addEventListener('GTMViewItemList', (event) => {
            this.viewItemListEvent(event);
        });

        // Begin checkout  event
        document.addEventListener('GTMBeginCheckout', (event) => {
            this.beginCheckoutEvent(event);
        });

        // Add shipping info event
        document.addEventListener('GTMAddShippingInfo', (event) => {
            this.addShippingInfoEvent(event);
        });

        // Add payment info event
        document.addEventListener('GTMAddPaymentInfo', (event) => {
            this.addPaymentInfoEvent(event);
        });

        // Purchase event
        document.addEventListener('GTMPurchase', (event) => {
            this.purchaseEvent(event);
        });

        // Select item event
        document.addEventListener('GTMSelectItem', (event) => {
            this.selectItemEvent(event);
        });
    }

    /**
     * Event listener for amount changed
     *
     * @param event
     */
    eventListenerAmountChanged (event) {
        let inputObject = event.detail.inputObject,
            currentQuantity = parseInt(inputObject.dataset.currentQty),
            newQuantity = parseInt(inputObject.value);

        // Check if the new quantity is NaN: set to 0
        if (isNaN(newQuantity)) {
            newQuantity = 0;
        }
        // Check if the new quantity is greater than the current quantity: add to cart event
        if (newQuantity > currentQuantity) {
            this.addToCartEvent(inputObject)
        }

        // Check if the new quantity is less than the current quantity: remove from cart event
        if (newQuantity < currentQuantity) {
            this.removeFromCartEvent(inputObject)
        }

        // Set current quantity to the new quantity
        inputObject.dataset.currentQty = newQuantity;
    }

    /**
     * View item event
     *
     * @param event
     */
    viewItemEvent(event) {
        let ecommerce = {},
            items = [],
            prices = [],
            self = this;

        ecommerce.currency = userCurrency;

        if (document.querySelector('.simple-product')) {
            let item = {},
                price = document.querySelector('.price-block strong') ? self.formatPrice(document.querySelector('.price-block strong').innerHTML.trim()) : '';

            ecommerce.value = price

            item.item_id      = document.querySelector('.product') ? document.querySelector('.product').dataset.modelno : '';
            item.item_name    = document.querySelector('.product-header-block h1').innerHTML.trim();
            item.category     = document.querySelector('.product') ? document.querySelector('.product').dataset.category : '';
            item.price        = price;

            items.push(item);
        } else {
            let productElements = document.querySelectorAll('.item-row'),
                pricesElements = document.querySelectorAll('.item-row .item-colors strong');

            if (pricesElements) {
                pricesElements.forEach(function (pricesElement) {
                    prices.push(pricesElement.innerText.match(priceFormat));
                });
            }

            ecommerce.value = prices;

            productElements.forEach(function (element) {
                let item = {};

                item.item_id      = document.querySelector('.product') ? document.querySelector('.product').dataset.modelno : '';
                item.item_name    = document.querySelector('.product-header-block h1').innerHTML.trim();
                item.category     = document.querySelector('.product') ? document.querySelector('.product').dataset.category : '';
                item.item_variant = element.querySelector('.color') ? element.querySelector('.color').dataset.color : '';
                item.price        = element.querySelector('strong') ? element.querySelector('strong').innerHTML.trim().match(priceFormat) : '';

                items.push(item);
            })
        }

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('view_item', ecommerce);
    }

    /**
     * View item list event
     *
     * @param event
     */
    viewItemListEvent(event) {
        let ecommerce = {},
            items = [],
            catalogItems = document.querySelectorAll('.item'),
            self = this;

        ecommerce.item_list_id   = 'catalog';
        ecommerce.item_list_name = 'catalog';

        catalogItems.forEach(function(catalogItem) {
            let item = {},
                colors = [],
                colorElements = catalogItem.querySelectorAll('.item .item-colors .color');

            if (colorElements) {
                colorElements.forEach(function (colorElement) {
                    let color = colorElement.dataset.color;

                    colors.push(color);
                });
            }

            item.item_id        = catalogItem.dataset.modelNo;
            item.item_name      = catalogItem.querySelector('.info-block h5 a') ? catalogItem.querySelector('.info-block h5 a').innerHTML : '';
            item.item_list_id   = 'catalog';
            item.item_list_name = 'catalog';
            item.item_variant   = colors;
            item.price          = catalogItem.querySelector('.price') ? self.formatPrice(catalogItem.querySelector('.price').innerHTML.trim()) : '';

            items.push(item);
        })

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('view_item_list', ecommerce);
    }

    beginCheckoutEvent(event) {
        let ecommerce = {},
            items = [],
            productElements = document.querySelectorAll('.shopping-cart-item'),
            self = this;

        ecommerce.currency = userCurrency;
        ecommerce.value = document.getElementById('total-price') ? document.getElementById('total-price').dataset.totalPrice : '';
        ecommerce.coupon = '';

        productElements.forEach(function (element) {
            let item = {};

            item.item_id      = element.dataset.modelNo;
            item.item_name    = element.dataset.modelDescription;
            item.item_variant = element.querySelector('.info-block h5') ? element.querySelector('.info-block h5').innerText : '';
            item.price        = element.querySelector('.price-block--price') ? self.formatPrice(element.querySelector('.price-block--price').innerHTML.trim()) : '';
            item.quantity     = element.querySelector('.input_variant_qty') ? element.querySelector('.input_variant_qty').innerHTML.trim() : '';

            items.push(item);
        });

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('begin_checkout', ecommerce);
    }

    /**
     * Add shipping info event
     *
     * @param event
     */
    addShippingInfoEvent(event) {
        if (event.detail.selectedShippingMethod.value > 0) {
            let ecommerce = {},
                items = [],
                productElements = document.querySelectorAll('.shopping-cart-item'),
                self = this;

            ecommerce.currency      = userCurrency;
            ecommerce.value         = document.getElementById('total-price') ? document.getElementById('total-price').dataset.totalPrice : '';
            ecommerce.coupon        = document.getElementById('discountcode_data') ? document.getElementById('discountcode_data').dataset.discountcode : '';
            ecommerce.shipping_tier = event.detail.selectedShippingMethod.innerText.trim();

            productElements.forEach(function (element) {
                let item = {};

                item.item_id      = element.dataset.modelNo;
                item.item_name    = element.dataset.modelDescription;
                item.item_variant = element.querySelector('.info-block h5') ? element.querySelector('.info-block h5').innerText : '';
                item.price        = element.querySelector('.price-block--price') ? self.formatPrice(element.querySelector('.price-block--price').innerHTML.trim()) : '';
                item.quantity     = element.querySelector('.input_variant_qty') ? element.querySelector('.input_variant_qty').innerHTML.trim() : '';

                items.push(item);
            });

            ecommerce.items = items;

            GoogleTagManager.pushToGoogle('add_shipping_info', ecommerce);
        }
    }

    /**
     * Add payment info event
     *
     * @param event
     */
    addPaymentInfoEvent(event) {
        let ecommerce = {},
            items = [],
            productElements = document.querySelectorAll('.shopping-cart-item'),
            self = this;

        ecommerce.currency     = userCurrency;
        ecommerce.value        = document.getElementById('total-price') ? document.getElementById('total-price').dataset.totalPrice : '';
        ecommerce.coupon       = document.getElementById('discountcode_data') ? document.getElementById('discountcode_data').dataset.discountcode : '';
        ecommerce.payment_type = event.detail.paymentmethodName;

        productElements.forEach(function (element) {
            let item = {};

            item.item_id        = element.dataset.modelNo;
            item.item_name      = element.dataset.modelDescription;
            item.item_list_id   = window.location.pathname;
            item.item_list_name = window.location.pathname;
            item.item_variant   = element.querySelector('.info-block h5') ? element.querySelector('.info-block h5').innerText : '';
            item.price          = element.querySelector('.price-block--price') ? self.formatPrice(element.querySelector('.price-block--price').innerHTML.trim()) : '';
            item.quantity       = element.querySelector('.input_variant_qty') ? element.querySelector('.input_variant_qty').innerHTML.trim() : '';

            items.push(item);
        })

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('add_payment_info', ecommerce);
    }

    /**
     * Purchase event
     *
     * @param event
     */
    purchaseEvent(event) {
        let ecommerce = {},
            items = [],
            productElements = document.querySelectorAll('.gtm-order-data-details'),
            self = this;

        ecommerce.transaction_id = document.querySelector('.gtm-order-data').dataset.transactionId;
        ecommerce.value          = document.querySelector('.gtm-order-data').dataset.value;
        ecommerce.tax            = document.querySelector('.gtm-order-data').dataset.tax;
        ecommerce.shipping       = document.querySelector('.gtm-order-data').dataset.shipping;
        ecommerce.currency       = userCurrency;
        ecommerce.coupon         = document.querySelector('.gtm-order-data').dataset.coupon;

        productElements.forEach(function (element) {
            let item = {};

            item.item_id        = element.dataset.itemId;
            item.item_name      = element.dataset.itemName;
            item.item_variant   = element.dataset.itemVariant;
            item.price          = element.dataset.price;
            item.quantity       = element.dataset.quantity;
            item.item_category  = element.dataset.category;
            item.item_brand     = element.dataset.brand;

            items.push(item);
        })

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('purchase', ecommerce);
    }

    /**
     * Select item event
     *
     * @param event
     */
    selectItemEvent(event) {
        let itemElement = event.detail.itemElement,
            ecommerce = {},
            items = [],
            pathName = window.location.pathname;

        ecommerce.item_list_id   = event.detail.itemListId ?? pathName;
        ecommerce.item_list_name = event.detail.itemListName ?? pathName;

        let item = {},
            colors = [],
            prices = [],
            quantities = [],
            colorElements = event.detail.colorElements ? event.detail.colorElements : [];

        if (colorElements) {
            colorElements.forEach(function (colorElement) {
                let color = colorElement.dataset.colorId ?? colorElement.dataset.color,
                    price = colorElement.querySelector('.price') ? colorElement.querySelector('.price').innerText.trim() : '',
                    quantity = colorElement.querySelector('.input_variant_qty') ? colorElement.querySelector('.input_variant_qty').value : '';

                colors.push(color);

                if (price !== '') {
                    prices.push(price);
                }

                if (quantity !== '') {
                    quantities.push(quantity);
                }
            });
        }

        item.item_id        = event.detail.itemId;
        item.item_name      = event.detail.itemName;
        item.item_list_id   = pathName;
        item.item_list_name = pathName;
        item.item_variant   = colors;

        if (prices.length > 0) {
            item.price = prices;
        } else {
            item.price = event.detail.itemPrice;
        }

        if (event.detail.itemQuantity) {
            item.quantity = event.detail.itemQuantity;
        } else if (itemElement.querySelector('.plus-and-minus') && itemElement.querySelector('.input_variant_qty')) {
            item.quantity = itemElement.querySelector('.input_variant_qty').value ?? '';
        } else if (quantities.length > 0) {
            item.quantity = quantities;
        }

        items.push(item);

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('select_item', ecommerce);
    }

    /**
     * Add to cart event
     */
    addToCartEvent(element) {
        let ecommerce = {},
            items = [],
            color = element ? atob(element.dataset.color) : '',
            size = element ? atob(element.dataset.size) : '';

        ecommerce.currency = userCurrency;
        ecommerce.value    = element ? (element.value * element.dataset.variantPrice).toFixed(2) : '';

        let item = {};

        item.item_id        = element ? atob(element.dataset.model) : '';
        item.item_name      = element ? atob(element.dataset.modelDescription) : '';
        item.item_list_id   = window.location.pathname;
        item.item_list_name = window.location.pathname;
        item.item_variant   = color + '/' + size;
        item.price          = element ? element.dataset.variantPrice : '';
        item.quantity       = element ? element.value : '';

        items.push(item);

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('add_to_cart', ecommerce);
    }

    /**
     * Remove from cart event
     */
    removeFromCartEvent(element) {
        let ecommerce = {},
            items = [],
            color = element ? atob(element.dataset.color) : '',
            size = element ? atob(element.dataset.size) : '';

        ecommerce.currency = userCurrency;
        ecommerce.value    = element ? (element.value * element.dataset.variantPrice).toFixed(2) : '';

        let item = {};

        item.item_id        = element ? atob(element.dataset.model) : '';
        item.item_name      = element ? atob(element.dataset.modelDescription) : '';
        item.item_list_id   = window.location.pathname;
        item.item_list_name = window.location.pathname;
        item.item_variant   = color + '/' + size;
        item.price          = element ? element.dataset.variantPrice : '';
        item.quantity       = element ? element.value : '';

        items.push(item);

        ecommerce.items = items;

        GoogleTagManager.pushToGoogle('remove_from_cart', ecommerce);
    }

    /**
     * Push data to Google
     *
     * @param eventName string
     * @param ecommerceObject object
     */
    static pushToGoogle(eventName, ecommerceObject) {
        let event = { event: eventName };

        ecommerceObject.items.forEach( function (item) {
            item.item_id ? item.item_id : item.item_id = '';
            item.item_name ? item.item_name : item.item_name = '';
            item.affiliation = document.location.host;
            item.coupon ? item.coupon : item.coupon = '';
            item.discount ? item.discount : item.discount = 0;
            item.index ? item.index : item.index = '';
            item.item_brand ? item.item_brand : item.item_brand = '';
            item.item_category ? item.item_category : item.item_category = '';
            item.item_category2 ? item.item_category2 : item.item_category2 = '';
            item.item_category3 ? item.item_category3 : item.item_category3 = '';
            item.item_category4 ? item.item_category4 : item.item_category4 = '';
            item.item_category5 ? item.item_category5 : item.item_category5 = '';
            item.item_list_id ? item.item_list_id : item.item_list_id = '';
            item.item_list_name ? item.item_list_name : item.item_list_name = '';
            item.item_variant ? item.item_variant : item.item_variant = '';
            item.price ? item.price : item.price = '';
            item.quantity ? item.quantity : item.quantity = '';
        });

        event.ecommerce = ecommerceObject;

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(event);
    }

    /**
     * Format the price
     * Remove the currency symbol and replace the comma with a dot
     *
     * @param price
     * @returns {string}
     */
    formatPrice(price) {
        let priceFormat = /[0-9,.]+/g;

        return price.match(priceFormat)[0].replace(',', '.');
    }
}
